export default __webpack_public_path__ + "static/1-4614fb840c7ea9fb18755e8b2370839c.webp";